export default function initWorkHandler() {
    const work = document.querySelector('#works')
    if(work){
        $.get(`${theme_url}/blocks/loophandlers/work-handler.php`,function(data){
            work.innerHTML = data
        })
    }
}